import connectionProxy from './connectionProxy'
import { isIe11 } from '../utils/ie'

export const getAreas = term => {
  if (isIe11()) {
    return connectionProxy.http.get(`/areas/buscar`, {
      params: {
        term
      }
    })
  }

  return connectionProxy.http.get(`/areas/buscar?term=${term}`)
};



// WEBPACK FOOTER //
// ./src/api/area.js